import { render, staticRenderFns } from "./VirtualFnoNetwork.vue?vue&type=template&id=5de64487&"
import script from "./VirtualFnoNetwork.vue?vue&type=script&lang=js&"
export * from "./VirtualFnoNetwork.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports